import React, { useState } from "react";
import Logo from "../Assets/img/LogoMMASM.png";
import "../index.css";
import { RiGridFill } from "react-icons/ri";
import { FiSearch } from "react-icons/fi";
import { Navbar } from "./Navbar";
import useComponentVisible from "../Context/hook/useComponentVisible";
import { MdCancel } from "react-icons/md";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { useDispatch } from "react-redux";
import { filterActions } from "../store/filter";
import { useNavigate } from "react-router-dom";
function AppHeader({
  serviceName,
  searchBar,
  authMenu,
  noAuthMenu,
  preName,
  className,
}) {
  const navigate = useNavigate();
  const { ref, isComponentVisible, toggle } = useComponentVisible(false);
  const dispatch = useDispatch();
  const isPhonePortOrMinor = useMediaQuery({
    query: "(max-width: 56.25em)",
  });

  const handleSearch = (event) => {
    event.preventDefault();
    const value = event.target[0].value;
    dispatch(
      filterActions.filterSelected({ method: "bySearchBar", value: value })
    );
    navigate("/catalog");
  };

  const [value, setValue] = useState(false);

  function handleClick() {
    setValue((value) => !value);
  }

  let toggleClassCheck = value ? "hide" : "";
  let toggleClassShow = value ? "show" : "";

  return (
    <header
      ref={ref}
      className={`h-[10vh] bg-[#003670] ${
        value ? "mb-28" : "mb-0"
      } ${className}`}
    >
      <div className="h-fit w-[90vw]  mx-auto my-auto">
        <div className="flex h-[10vh] relative ">
          <Link
            to="/"
            className="flex flex-row left-0 -translate-y-1/2 top-1/2 absolute"
          >
            <div
              className={`${
                isPhonePortOrMinor ? "" : "sideLittle"
              } h-fit flex text-center my-auto`}
            >
              <img className="w-[8em] tab-port:w-[6em]" src={Logo} alt="Logo" />
            </div>
            <span className="text-2xl tab-port:text-xl ml-0 tab-port:ml-4 w-56 my-auto h-fit text-white">
              {preName ?? "Sistema de"}
              <br />
              <p className="leading-none text-white font-bold">{serviceName}</p>
            </span>
          </Link>

          <div className="flex items-center -translate-y-1/2 top-1/2 absolute right-0">
            <div className="search">
              <div
                className={`cancel-icon ${toggleClassShow}`}
                onClick={handleClick}
              >
                {value && (
                  <span>
                    <MdCancel className="text-white text-6xl" />
                  </span>
                )}
              </div>
              {isPhonePortOrMinor && (
                <div
                  className={`search-icon ${toggleClassCheck}`}
                  onClick={handleClick}
                >
                  {!value && (
                    <span>
                      <FiSearch className="text-white text-6xl" />
                    </span>
                  )}
                </div>
              )}
              <form
                className={`search-bar ${toggleClassShow}`}
                onSubmit={handleSearch}
              >
                <input type="text" placeholder={`Buscar ${searchBar}`} />
                <button type="submit">
                  <FiSearch className="icono" />
                </button>
              </form>
            </div>
            <div className="flex flex-row">
              <div className="w-[2px] mx-10 bg-[#6e8dae] text-[#6e8dae] h-12/12">
                .
              </div>
              <div className="mt-2">
                <button className="" onClick={() => toggle(true)}>
                  <RiGridFill className="text-white text-6xl leading-3" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Navbar
        active={isComponentVisible}
        toggle={toggle}
        authMenu={authMenu}
        noAuthMenu={noAuthMenu}
      ></Navbar>
    </header>
  );
}

export default AppHeader;
